<template>
    <div>
        <div
            v-for="option in filter.inputs.mode.options"
            :key="option.value"
            class="form-group form-group-32"
        >
            <label class="form-label label-auto">
                <input v-model="mode" type="radio" :value="option.value" />
                {{ labelForThirdFilter(option.label) }}
            </label>

            <div
                v-if="
                    (mode === 'contain' && option.value === 'contain') ||
                    (mode === 'dontcontain' && option.value === 'dontcontain')
                "
                class="form-input-block"
            >
                <autocomplete
                    :type="filter.inputs.choices.options.type"
                    :max="filter.inputs.choices.options.max"
                    :name="filter.inputs.choices.name"
                    :params="filter.inputs.choices.options.params"
                    :prepopulate="choices"
                    :searchname="filter.inputs.choices.options.searchName"
                    :more="filter.inputs.choices.options.more"
                    @updated="updateAutocomplete"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';
import Autocomplete from 'vcomponents/utilities/Autocomplete.vue';

export default {
    components: {
        Autocomplete,
    },
    mixins: [ListingFilterMixin],
    data() {
        return {
            mode: '',
            choices: [],
        };
    },

    computed: {
        data() {
            return {
                mode: this.mode,
                choices: this.choices,
            };
        },
    },
    methods: {
        updateAutocomplete(items) {
            this.choices = [];

            for (var i in items) {
                const reduced = {
                    id: items[i].id,
                    name: items[i].name,
                    value: items[i].value,
                };
                this.choices.push(reduced);
            }
        },
        labelForThirdFilter(label) {
            if (this.filter.name === 'thirds') {
                switch (label) {
                    case 'Contient':
                        label = this.$l10n.__('Est');
                        break;
                    case 'Ne contient pas':
                        label = this.$l10n.__("N'est pas");
                        break;
                }
            }
            return label;
        },
    },
};
</script>
